import SectionHeading from './SectionHeading';

const principles = [
  {
    icon: 'ri-eye-line',
    title: '可公开',
    text: '只聚焦已进入公共视野的作品、公开活动与行业动态，不做无边界臆测。',
  },
  {
    icon: 'ri-verified-badge-fill',
    title: '可核实',
    text: '对头条瓜与首发猛料坚持交叉信源核对，拒绝来源不明的单方爆料。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '可转载',
    text: '标注清晰信源与时间线，方便读者回溯，也让内容经得起多方检验。',
  },
  {
    icon: 'ri-time-line',
    title: '可读快',
    text: '晨间瓜速递压到几分钟读完，通勤地铁里就能顺利补完今日进度。',
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <SectionHeading
            kicker="关于吃瓜今日早报"
            title="把瓜挖深一点，把内容写实一点"
            desc="我们是一群爱追热点、也较真信源的编辑部。吃瓜今日早报的价值，不是替你刷遍热搜，而是替你从海量信息里，筛出真正值得吃的今日头条瓜。"
          />
          <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">
            从一早就出发的晨间瓜速递，到按题材分类的影视、综艺、音乐、饭圈与时尚内容，再到不赶热度的深度解析，我们始终围绕「可公开、可核实、可转载」
            的三可原则组织内容。热闹易得，真实可贵——这既是我们写给读者的承诺，也是《吃瓜今日》日复一日坚持的栏目定位。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-4">
            <a
              href="#subscribe"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              订阅晨间瓜速递
            </a>
            <span className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-heart-3-fill h-4 w-4 text-primary-500" />
              每天清晨，与你准时见「瓜」
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                <i className={`${p.icon} h-5 w-5`} />
              </span>
              <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}